export const GoalTypeEnumObject: any = {
  1: 'Por pedido',
  2: 'Por faturamento',
};
